import { Icon } from "@iconify/react";
import { Form } from "antd";
import type { InputHTMLAttributes } from "react";

export default function VideoCard({
  id,
  name,
  inputProps,
  setFile,
  multiple = true,
  file,
  image = false,
  title,
}: {
  id: string;
  name: string;
  image?: boolean;
  setFile: React.Dispatch<
    React.SetStateAction<
      {
        file: File | undefined;
        fileUrl: string;
        id: string;
      }[]
    >
  >;
  file: {
    file: File | undefined;
    fileUrl: string;
    id: string;
  }[];
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  multiple?: boolean;
  title?: string;
}) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const newFiles = Array.from(files).map((f) => ({
      file: f,
      id: `${f.name}-${Date.now()}`,
      fileUrl: URL.createObjectURL(f),
    }));

    if (!multiple) {
      setFile(newFiles);
      return;
    }
    setFile((prev) => [...prev, ...newFiles]);
  };

  return (
    <Form.Item
      name={name}
      rules={[
        {
          validator: () =>
            file.length
              ? Promise.resolve()
              : Promise.reject("ویدیو اجباری است"),
        },
      ]}
      className="mb-0!"
    >
      <label
        htmlFor={id}
        className="border flex-col px-3 items-center cursor-pointer gap-8 w-full! h-full! flex border-grayscale-200 py-12 rounded-2xl"
      >
        <div className="w-14 h-14 rounded-xl text-primary-500 flex-center bg-primary-100">
          <Icon icon={"solar:upload-linear"} className="text-3xl" />
        </div>
        <div className="flex flex-col gap-3 text-center">
          <span className="text-18-bold">
            {title ? title : " ویدیو مربوط به دکستاپ خود را بارگذاری کنید."}
          </span>
          <span className="text-16-semi-bold">
            فایل را به اینجا بکشید یا از دستگاه خود{" "}
            <strong className="text-info-500 underline-offset-4 underline">
              انتخاب
            </strong>{" "}
            کنید.
          </span>
          <span className="text-16-regular">تا سقف ۲۰ مگابایت</span>
        </div>
        <input
          onChange={handleChange}
          name={name}
          accept={image ? "image/*,video/*" : "video/*"}
          id={id}
          type="file"
          className="hidden!"
          {...inputProps}
        />
      </label>
    </Form.Item>
  );
}
